"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchApplicationFeaturesFailure = exports.fetchApplicationFeaturesSuccess = exports.fetchApplicationFeaturesRequest = exports.FETCH_APPLICATION_FEATURES_FAILURE = exports.FETCH_APPLICATION_FEATURES_SUCCESS = exports.FETCH_APPLICATION_FEATURES_REQUEST = void 0;
const typesafe_actions_1 = require("typesafe-actions");
// Fetch all application features
exports.FETCH_APPLICATION_FEATURES_REQUEST = '[Request] Fetch application features';
exports.FETCH_APPLICATION_FEATURES_SUCCESS = '[Success] Fetch application features';
exports.FETCH_APPLICATION_FEATURES_FAILURE = '[Failure] Fetch application features';
const fetchApplicationFeaturesRequest = (apps) => (0, typesafe_actions_1.action)(exports.FETCH_APPLICATION_FEATURES_REQUEST, { apps });
exports.fetchApplicationFeaturesRequest = fetchApplicationFeaturesRequest;
const fetchApplicationFeaturesSuccess = (apps, features) => (0, typesafe_actions_1.action)(exports.FETCH_APPLICATION_FEATURES_SUCCESS, {
    apps,
    features
});
exports.fetchApplicationFeaturesSuccess = fetchApplicationFeaturesSuccess;
const fetchApplicationFeaturesFailure = (apps, error) => (0, typesafe_actions_1.action)(exports.FETCH_APPLICATION_FEATURES_FAILURE, { apps, error });
exports.fetchApplicationFeaturesFailure = fetchApplicationFeaturesFailure;
//# sourceMappingURL=actions.js.map